import { UNASSIGNED } from "./constants";

export const plural = (n, w) => `${n} ${w}${n === 1 ? "" : "s"}`;

// Group contracts by agent name; unassigned always sorts last.
export function groupByAgent(contracts) {
  const map = new Map();
  for (const c of contracts) {
    const key = c.agent
      ? `${c.agent.firstName} ${c.agent.lastName}`
      : UNASSIGNED;
    if (!map.has(key)) map.set(key, []);
    map.get(key).push(c);
  }
  return [...map.entries()].sort(([a], [b]) => {
    if (a === UNASSIGNED) return 1;
    if (b === UNASSIGNED) return -1;
    return a.localeCompare(b);
  });
}
